import { useMemo } from 'react'
import { useBillsDataQuery } from '../../../../graphql/generated/graphql'
import { useEntityStatus } from '../useEntityStatus'

export const useBills = () => {
    const { data, loading } = useBillsDataQuery()
    const { loading: entityStatusLoading, canAddBills } = useEntityStatus()

    const { connectedBills, disconnectedBills, subscriptions } = useMemo(() => {
        const bills = data?.bills ?? []
        const subscriptions = data?.subscriptions ?? []
        const connectedBills = bills?.filter((bill) => bill.connected)
        const disconnectedBills = bills?.filter((bill) => !bill.connected)
        return { connectedBills, disconnectedBills, subscriptions }
    }, [data?.bills, data?.subscriptions])

    const bankAccounts = data?.bankAccounts ?? []

    const hasConnectedBills = connectedBills.length > 0 || bankAccounts.length > 0
    const hasDisconnectedBills = disconnectedBills.length > 0

    const shouldOpenConnectDialog = !hasConnectedBills && hasDisconnectedBills

    return {
        loading: loading || entityStatusLoading,
        hasConnectedBills,
        canAddBills,
        connectedBills,
        subscriptions,
        bankAccounts,
        shouldOpenConnectDialog,
    }
}
